document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('input:not([type="checkbox"]):not([type="file"]):not([type="radio"]),textarea');
    inputs.forEach((input, index) => {
        input.addEventListener('focus', () => {
            document.body.classList.add('keyboard-show');
        });
        input.addEventListener('blur', () => {
            document.body.classList.remove('keyboard-show');
        });
    });
});
